import { Injectable } from '@angular/core';
import * as configcat from 'configcat-js-ssr';
import { IConfigCatClient, LogLevel, PollingMode } from 'configcat-js-ssr';
import { environment } from '~env/environment';
import { BehaviorSubject } from 'rxjs';
import { NUMBER_60 } from '~shared/constants';

@Injectable({
  providedIn: 'root',
})
/**
 * @class ConfigcatApiService
 * @package-private
 * @description This class will create a configcat instance using the key created in the config cat dashboard
 */
export class ConfigcatApiService {
  private static client: IConfigCatClient;

  private get logger() {
    const logLevel = environment.production ? LogLevel.Off : LogLevel.Info;
    return configcat.createConsoleLogger(logLevel);
  }

  public ready$ = new BehaviorSubject(false);

  public createInstance(): any {
    if (!ConfigcatApiService.client) {
      const options = {
        logger: this.logger,
        pollIntervalSeconds: NUMBER_60,
      };

      ConfigcatApiService.client = configcat.getClient(environment.configCatSdkKey(),
        PollingMode.AutoPoll,
        options);
      ConfigcatApiService.client.forceRefreshAsync().then( () => this.ready$.next(true) );
    }

    return ConfigcatApiService.client;
  }
}
